function play() {
  document.querySelector('.ar-landing__text').className = 'ar-landing__text';
  requestAnimationFrame((time) => {
    requestAnimationFrame((time) => {
      document.querySelector('.ar-landing__text').className = "ar-landing__text changing";
    });
  });
}

function changeSlide(fromSlide, toSlide) {
  let slideClass = '.ar-landing__slide--',
      slideFrom = document.querySelector(slideClass + fromSlide),
      slideTo = document.querySelector(slideClass + toSlide);

  // if (fromSlide == 4) {
  //   slideFrom.classList.add("ar-landing__slide--inactive");
  //   slideFrom.classList.remove("ar-landing__slide--active");
  //   slideTo.classList.remove("ar-landing__slide--inactive");
  //   slideTo.classList.add("ar-landing__slide--active");
  // }
  // else {
    slideFrom.classList.add('fade-out--slide','animating');

    slideFrom.addEventListener('animationend', (animation) => {
      const animationName = animation.animationName;

      if (animationName === 'fadeOut') {
        console.log('fadeOut done');
        // slideFrom.classList.add('fade-out--complete');
        slideFrom.classList.add('ar-landing__slide--inactive');
        slideFrom.classList.remove('ar-landing__slide--active');
        slideTo.classList.remove('ar-landing__slide--inactive');
        slideTo.classList.add('ar-landing__slide--active');
        // slideFrom.classList.remove('fade-out','fade-out--complete');
        slideFrom.classList.remove('fade-out--slide','animating');
      }
    });

    slideTo.classList.add('fade-in--slide', 'animating');
  // }
}

const slideContainer = document.querySelector('.ar-landing__slides');
const slides = slideContainer.querySelectorAll('.ar-landing__slide');

for (const slide of slides) {
  console.log(slide);

  const slideTexts = slide.querySelectorAll(".ar-landing__text");

  for (const slideText of slideTexts) {
    // slideText.addEventListener('animationend', (animation) => {
    //   const animationName = animation.animationName;

    //   if (animationName === 'fadeIn') {
    //     console.log('fadeIn done');
    //     // slideText.classList.add('fade-in--complete');
    //   }

    //   if (animationName === 'slideRight-1-1') {
    //     console.log('slideRight-1-1 done');
    //     slideText.classList.add('slide-right-1-1--complete');
    //   }

    //   if (animationName === 'slideLeft-1-2') {
    //     console.log('slideLeft-1-2 done');
    //     slideText.classList.add('slide-left-1-2--complete');
    //   }

    //   if (animationName === 'slideRight-1-4') {
    //     console.log('slideRight-1-4 done');
    //     slideText.classList.add('slide-right-1-4--complete');
    //     // changeSlide('1', '2');
    //   }

    //   if (animationName === 'slideRight-2-4') {
    //     console.log('slideRight-2-4 done');
    //     slideText.classList.add('slide-right-2-4--complete');
    //     // changeSlide('2', '3');
    //   }

    //   if (animationName === 'slideRight-3-1') {
    //     // hide text 1 and unset text 5 height in effort
    //     // to keep text 2 and 3 in place
    //     console.log('slideRight-3-1 (fadeInOut) done');
    //     slideText.classList.add('slide-right-3-1--complete');
    //     document.querySelector('.ar-landing__slide--4 .ar-landing__text--5').style.height = "unset"
    //   }

    //   if (animationName === 'slideRight-3-4') {
    //     console.log('slideRight-3-4 done');
    //     slideText.classList.add('slide-right-3-4--complete');
    //   }

    //   if (animationName === 'slideRight-3-5') {
    //     console.log('slideRight-3-5 done');
    //     slideText.classList.add('slide-right-3-5--complete');
    //     animationStart(document.querySelector('.ar-landing__slide--4 .ar-landing__text--2'));
    //   }

    // });
  }

}

let animationIsPaused = false,
    animationStep = 0,
    slideStep = 1;

function startSequence() {
  // setTimeout(() => {
  //   animationStart(document.querySelector('.ar-landing__slide--1 .ar-landing__text--2'));
  //   animationStart(document.querySelector('.ar-landing__slide--1 .ar-landing__text--3'));
  // }, "1000");
  // animationStep++;

  // setTimeout(() => {
  //   animationStart(document.querySelector('.ar-landing__slide--1 .ar-landing__text--1'));
  //   animationStart(document.querySelector('.ar-landing__slide--1 .ar-landing__text--4'));
  // }, "3000");
  // animationStep++;

  animationStart(
    document.querySelector(".ar-landing__slide--1 .ar-landing__text-container")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--1 .ar-landing__text--1")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--1 .ar-landing__text--2")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--1 .ar-landing__text--3")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--1 .ar-landing__text--4")
  );

  setTimeout(() => {
    changeSlide("1", "2");
  }, "3500");

  setTimeout(() => {
    animationStart(
      document.querySelector(".ar-landing__slide--2 .ar-landing__text-container")
    );
  }, "5500");
  animationStart(
    document.querySelector(".ar-landing__slide--2 .ar-landing__text--1")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--2 .ar-landing__text--2")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--2 .ar-landing__text--3")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--2 .ar-landing__text--4")
  );

  setTimeout(() => {
    changeSlide("2", "3");
  }, "8500");

  setTimeout(() => {
    animationStart(
      document.querySelector(
        ".ar-landing__slide--3 .ar-landing__text-container"
      )
    );
  }, "10500");
  animationStart(
    document.querySelector(".ar-landing__slide--3 .ar-landing__text--1")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--3 .ar-landing__text--2")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--3 .ar-landing__text--3")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--3 .ar-landing__text--4")
  );

  setTimeout(() => {
    changeSlide("3", "4");
  }, "14000");

  setTimeout(() => {
    animationStart(
      document.querySelector(
        ".ar-landing__slide--4 .ar-landing__text-container"
      )
    );
  }, "16000");
  animationStart(
    document.querySelector(".ar-landing__slide--4 .ar-landing__text--1")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--4 .ar-landing__text--2")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--4 .ar-landing__text--3")
  );
  // animationStart(document.querySelector('.ar-landing__slide--4 .ar-landing__text--4'));

  setTimeout(() => {
    changeSlide("4", "5");
  }, "19500");

  // setTimeout(() => {
  //   document.querySelector(".skip-to-ar").hidden = true;
  // }, "21500");

  animationStart(
    document.querySelector(".ar-landing__slide--5 .ar-landing__text-container")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--5 .ar-landing__text--1")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--5 .ar-landing__text--2")
  );
  animationStart(
    document.querySelector(".ar-landing__slide--5 .ar-landing__text--3")
  );
  animationStart(
    document.querySelector('.ar-landing__slide--5 .ar-landing__text--4')
  );
  animationStart(
    document.querySelector(".ar-landing__slide--5 .ar-landing__text-supplemental")
  );
  animationStart(document.querySelector(".skip-to-ar"));

  // setTimeout(() => {
  //   animationStart(document.querySelector('.ar-landing__slide--2 .ar-landing__text--2'));
  //   animationStart(document.querySelector('.ar-landing__slide--2 .ar-landing__text--3'));
  // }, "11000");
  // animationStep++;

  // setTimeout(() => {
  //   animationStart(document.querySelector('.ar-landing__slide--2 .ar-landing__text--1'));
  //   animationStart(document.querySelector('.ar-landing__slide--2 .ar-landing__text--4'));
  // }, "13000");
  // animationStep++;
}

setTimeout(() => {
  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  const windowWidth = window.innerWidth;
  console.log(mediaQuery.matches);
  console.log(windowWidth);
  if (windowWidth < 768) {
    reduceMotion();
  } else if (!mediaQuery.matches) {
    startSequence();
  } else {
    reduceMotion();
  }
}, "1000");

function reduceMotion() {

}

function restartSequence() {
  console.log('restarting sequence');
  animationStart(document.querySelector('.ar-landing__slide--1 .ar-landing__text--1'));
}

// setTimeout(() => {
//   restartSequence()
// }, "4000");

// function animationStart(el) {
//   el.classList.remove('animating');
//   let elClassList = el.classList.toString();

//   console.log(elClassList);

//   el.className = elClassList;

//   requestAnimationFrame((time) => {
//     requestAnimationFrame((time) => {
//       el.className = elClassList + " animating";
//     });
//   });
// }

